import type { BookingDetailsState } from '../../domain/types'
import type { Tabs } from '@/scopes/account/common/components/Hero'
import {
  ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC,
  ACCOUNT_GROUP_RESPONSIBLE_IMAGE_SRC,
} from '@/scopes/account/common/constants'
import { getDaysUntilDeparture as getDaysUntilDepartureFromDate, isOnHolidays } from '@/scopes/account/common/utils/bookingDates'

const GROUP_RESPONSIBLE_PAGE_PATH = '/groups/responsiblepage'

export function getBookingTitle(state: BookingDetailsState) {
  return state.accommodations[0]?.name || state.groupName || state.bookingNumber
}

export function getHeroBackgroundImageSrc(state: BookingDetailsState) {
  return state.isGroupResponsible
    ? ACCOUNT_GROUP_RESPONSIBLE_IMAGE_SRC
    : state.accommodations[0]?.imageUrl || ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC
}

export function isBookingOnHolidays(state: BookingDetailsState, now: Date = new Date()) {
  return isOnHolidays(state.rawDepartureDate, state.rawReturnDate, now)
}

export function getDaysUntilDeparture(state: BookingDetailsState, now: Date = new Date()): number | null {
  return getDaysUntilDepartureFromDate(state.rawDepartureDate, now)
}

export function getGroupResponsiblePageUrl(
  state: BookingDetailsState,
) {
  return (activeTab: Tabs): string => {
    const url = new URL(GROUP_RESPONSIBLE_PAGE_PATH, window.location.origin)
    const queryParams = url.searchParams
    queryParams.append('activeTab', activeTab)
    if (state.bookingNumber) {
      queryParams.append('bookingNumber', state.bookingNumber)
    }

    if (state.isTotallySnow) {
      queryParams.append('collection', 'totally_snow')
    }
    else if (state.isPrimavera) {
      queryParams.append('collection', 'primavera')
    }

    return `${GROUP_RESPONSIBLE_PAGE_PATH}?${queryParams.toString()}`
  }
}
